require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 421
// module chunks = 0